"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonLinkWithSpinner = void 0;
const react_1 = __importDefault(require("react"));
const loaders_and_spinners_1 = require("@kyruus/loaders-and-spinners");
const styled_components_1 = require("../common/styles/styled-components");
exports.ButtonLinkWithSpinner = react_1.default.forwardRef((_a, ref) => {
    var { mode = 'primary', showSpinner = false, children } = _a, props = __rest(_a, ["mode", "showSpinner", "children"]);
    const spinnerColor = 'currentColor';
    switch (mode) {
        case 'secondary':
            return (react_1.default.createElement(styled_components_1.SecondaryButtonLinkWithSpinner, Object.assign({ showSpinner: showSpinner }, props, { ref: ref }),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'tertiary':
            return (react_1.default.createElement(styled_components_1.TertiaryButtonLinkWithSpinner, Object.assign({ showSpinner: showSpinner }, props, { ref: ref }),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'quaternary':
            return (react_1.default.createElement(styled_components_1.QuaternaryButtonLinkWithSpinner, Object.assign({ showSpinner: showSpinner }, props, { ref: ref }),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'flat':
            return (react_1.default.createElement(styled_components_1.FlatButtonLinkWithSpinner, Object.assign({ showSpinner: showSpinner }, props),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'ghost':
            return (react_1.default.createElement(styled_components_1.GhostButtonLinkWithSpinner, Object.assign({ showSpinner: showSpinner }, props),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'contrast':
            return (react_1.default.createElement(styled_components_1.ContrastButtonLinkWithSpinner, Object.assign({ showSpinner: showSpinner }, props),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'floating-primary':
            return (react_1.default.createElement(styled_components_1.FloatingPrimaryButtonLinkWithSpinnner, Object.assign({ showSpinner: showSpinner }, props),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
        case 'primary':
        default:
            return (react_1.default.createElement(styled_components_1.PrimaryButtonLinkWithSpinner, Object.assign({ showSpinner: showSpinner }, props, { ref: ref }),
                react_1.default.createElement(styled_components_1.SpinningButtonContent, { showSpinner: showSpinner },
                    react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { color: spinnerColor }),
                    react_1.default.createElement("span", null, children))));
    }
});
exports.ButtonLinkWithSpinner.displayName = 'ButtonLinkWithSpinner';
//# sourceMappingURL=ButtonLinkWithSpinner.js.map